import { motion } from "framer-motion";
import { IMAGES } from "../../data";

const CARDS = [
  {
    img: IMAGES.heroSandalwood,
    title: "Sandalwood Logs",
    caption: "Aged heartwood logs — the raw, natural source.",
    span: "md:col-span-7",
    h: "h-[280px] md:h-[420px]",
  },
  {
    img: IMAGES.saffronThreads,
    title: "Kashmir Kesar",
    caption: "Hand-picked crimson saffron threads.",
    span: "md:col-span-5",
    h: "h-[280px] md:h-[420px]",
  },
  {
    img: IMAGES.sandalwoodIncense,
    title: "Chips · Powder · Oil",
    caption: "Sandalwood in every usable form.",
    span: "md:col-span-5",
    h: "h-[280px] md:h-[360px]",
  },
  {
    img: IMAGES.saffronMacro,
    title: "Iranian Kesar",
    caption: "All-red Persian saffron of the finest grade.",
    span: "md:col-span-7",
    h: "h-[280px] md:h-[360px]",
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] },
  }),
};

export const GalleryIntro = () => {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="bg-[#F4EFE6] text-[#1A1714]"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-24 md:py-32">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-3xl mb-16"
        >
          <p className="font-sans-lux text-xs uppercase tracking-[0.3em] text-[#B82925] mb-6">
            What We Trade
          </p>
          <h2 className="font-serif-lux font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#1A1714] mb-6">
            Two treasures of nature, <span className="italic text-[#B08033]">pure and simple.</span>
          </h2>
          <p className="font-sans-lux text-base md:text-lg text-[#5C554B] leading-relaxed">
            We deal in just two things — and we do them exceptionally well:
            fragrant <strong className="text-[#1A1714] font-medium">sandalwood</strong> and precious{" "}
            <strong className="text-[#1A1714] font-medium">saffron (kesar)</strong>. Natural, unadulterated, and
            traceable to their source.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {CARDS.map((c, i) => (
            <motion.figure
              key={c.title}
              custom={i}
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-60px" }}
              className={`group relative overflow-hidden ${c.span} ${c.h} bg-[#e7ded0]`}
            >
              <img
                src={c.img}
                alt={c.title}
                className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1A1714]/70 via-transparent to-transparent" />
              <figcaption className="absolute bottom-0 left-0 p-6 md:p-8">
                <p className="font-serif-lux text-2xl md:text-3xl text-[#F4EFE6]">{c.title}</p>
                <p className="font-sans-lux text-sm text-[#F4EFE6]/80 mt-1">{c.caption}</p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
